import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';
import { RubricMasterDTO } from 'src/app/model/observation/rubric/rubric-master-dto.model';
import { RubricCreateDTO } from 'src/app/model/observation/rubric/rubric-create-dto.model';
import { RubricSaveDTO } from 'src/app/model/observation/rubric/rubric-save-dto.model';
import { ObservationSummaryDTO } from 'src/app/model/observation/observation-summary-dto.model';

@Injectable()
export class RubricApi extends BaseApi {

    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getRubric(rubricId: string) {
        return this.http.get<RubricMasterDTO>(`${this.baseUri}/observation/rubric/${rubricId}`, {});
    }

    createRubric(createRubricDTO: RubricCreateDTO) {
        return this.http.post<ObservationSummaryDTO>(`${this.baseUri}/observation/rubric/create`, createRubricDTO);
    }

    saveRubric(rubricSaveDTO: RubricSaveDTO) {
        return this.http.post(`${this.baseUri}/observation/rubric/save`, rubricSaveDTO);
    }

    submitRubric(rubricSaveDTO: RubricSaveDTO) {
        return this.http.post(`${this.baseUri}/observation/rubric/submit`, rubricSaveDTO);
    }
}
